import { jsx as _jsx } from "react/jsx-runtime";
import { useOpenBalanceContext } from "../context/OpenBalanceContext";
import { ErrorTexts } from "./ErrorTexts";
import { OpenBalancePageSkeleton } from "./OpenBalancePageSkeleton";
import { OrderNotFound } from "./OrderNotFound";
import { PastCutoffMessage } from "./PastCutoff";
import { PaymentActions } from "./PaymentActions";
import { PaymentComplete } from "./PaymentComplete";
export const ComponentSwitcher = () => {
    const OBP = useOpenBalanceContext();
    if (OBP.isLoading) {
        return _jsx(OpenBalancePageSkeleton, {});
    }
    if (OBP.targetOrder === null) {
        return _jsx(OrderNotFound, {});
    }
    if (OBP.paymentComplete || OBP.isAlreadyPaid) {
        return _jsx(PaymentComplete, {});
    }
    if (OBP.isOrderPastCutoff) {
        return _jsx(PastCutoffMessage, {});
    }
    if (OBP.isOrderValidForPayment) {
        return _jsx(PaymentActions, {});
    }
    return _jsx(ErrorTexts, {});
};
